<template>
  <v-datepicker
    v-model="selected_date"
    :first-day-of-week="2"
    :mode="mode"
    :minute-increment="minute_increment"
    locale="es"
    show-iso-weeknumbers
    timezone="UTC"
    :attributes="attrs"
    :popover="popover"
  >
    <template #default="{ inputValue, togglePopover, inputEvents }">
      <div class="relative rounded-md shadow-s">
        <input
          type="text"
          :value="inputValue"
          v-on="inputEvents"
          :class="['input-text', invalidClass]"
          :readonly="readonly"
        />
        <div class="absolute inset-y-0 right-0 flex items-center">
          <i
            @click="selected_date = null"
            class="fa-solid fa-xmark cursor-pointer w-5 text-gray-400"
          ></i>
          <i
            @click.prevent="togglePopover"
            class="fa-solid fa-calendar-days cursor-pointer w-5 text-gray-400"
          ></i>
        </div>
      </div>
    </template>
  </v-datepicker>
</template>

<script>
import moment from "moment";
export default {
  name: "DateForm",
  props: {
    modelValue: {},
    mode: { type: String, default: "date" },
    minute_increment: { type: Number, default: 5 },
    readonly: { type: Boolean, default: true },
    invalidClass: { type: String, default: '' },
    outputFormat: { type: String }
  },
  data() {
    return {
      selected_date: this.modelValue,
      attrs: [
        {
          key: "today",
          highlight: {
            color: "blue",
            fillMode: "light"
          },
          dates: moment().format("YYYY-MM-DD")
        }
      ],
      popover: { visibility: "" }
    };
  },
  watch: {
    selected_date: function (val) {
      let out = val;

      // Si sólo necesitas la fecha:
      if (this.mode === 'date' && this.outputFormat) {
        // Evita el corrimiento usando moment.utc(...)
        out = moment.utc(val).format(this.outputFormat);
      } else if (this.outputFormat) {
        out = moment(val).format(this.outputFormat);
      }

      this.$emit('update:modelValue', out);
    }
  }
};
</script>
